// eslint-disable-next-line no-unused-vars
import * as React from 'react'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Layout } from '@/components/custom/layout.jsx'
import { navigateGuard } from '@/utils/auth.js'
import { UserRole } from '@/constants/user.js'

export const Route = createFileRoute('/_auth/settings')({
  beforeLoad: ({ location }) => {
    if (location.pathname === '/settings/tickets/view') {
      return navigateGuard(location, [
        UserRole.ADMINISTRATOR,
        UserRole.TEAM_LEADER,
      ])
    }

    return navigateGuard(location, [UserRole.ADMINISTRATOR])
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Layout.Body>
      <Outlet />
    </Layout.Body>
  )
}
